const LOCAL_STORAGE_KEYS = {
  FILE_IMPORT: "FILE_IMPORT",
  TIMESLOT_IMPORT: "TIMESLOT_IMPORT",
};
export default LOCAL_STORAGE_KEYS;
